import type {ProductManualDocument} from '@/types/sanity'

/** HTTP failures must reject so the drawer can offer recovery, not empty success. */
export async function loadProductDocuments(productNumber?: string, signal?: AbortSignal) {
  if (!productNumber) throw new Error()
  const params = new URLSearchParams({productNumber})
  const response = await fetch(`/api/product-documents?${params}`, {cache: 'no-store', signal})
  // A deleted/missing product is distinct from an unavailable dependency.
  if (response.status === 404) return []
  if (!response.ok) throw new Error('Documents unavailable')
  const data = await response.json()
  if (
    !Array.isArray(data?.documents) ||
    !data.documents.every(
      (document: unknown) =>
        document !== null && typeof document === 'object' && !Array.isArray(document),
    )
  )
    throw new Error()
  return data.documents as ProductManualDocument[]
}
